<template>
  <div>
    <b-container class="self-assesment">
      <b-row>
        <b-col xl="10" offset-xl="1">
          <b-form @submit.prevent="">
            <!-- Policies -->
            <fieldset
              v-for="(policies, key) in employmentPolicies"
              :key="key"
              class="fieldset employment"
            >
              <div v-if="shouldDisplayPolicy(key)">
                <template-status :status="status.assessment" />
                <div class="header">
                  <h2>
                    {{ $t("label_" + key + "_title") }}
                    <template-tooltip
                      :tooltip="'label_' + key + '_title_toolTip'"
                    />
                  </h2>
                </div>
                <div class="table">
                  <b-row
                    v-for="(q, index) in policies.questions"
                    :key="index"
                    class="form-group"
                  >
                    <b-col class="employment-policies">
                      <p class="index">
                        {{ $t(q.number) }}
                      </p>
                      <p class="question">
                        {{ $t("label_" + key + "_" + q.question) }}
                        <template-tooltip
                          :tooltip="
                            'label_' + key + '_' + q.question + '_toolTip'
                          "
                        />
                      </p>
                    </b-col>
                    <b-col md="3">
                      <b-form-select
                        :id="q.field"
                        v-model="q.answer"
                        class="mb-3"
                        :disabled="!canUpdateSelfAssessment"
                        @change.native="updateSelfAssessment"
                      >
                        <template slot="first">
                          <!-- this slot appears above the options from 'options' prop -->
                          <option value="null" disabled>
                            {{ $t("label_selfAssessment_optionList_default") }}
                          </option>
                        </template>
                        <option
                          v-for="(item, itemIndex) in getOptionListByName(
                            'optionList_selfAssessment_employmentPolicies_responses'
                          )"
                          :key="itemIndex"
                          :value="item.name"
                        >
                          {{ $t(item.name) }}
                        </option>
                      </b-form-select>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </fieldset>
            <!-- End - Policies -->
          </b-form>
        </b-col>
      </b-row>
      <b-row v-if="canUpdateSelfAssessment" align-h="center">
        <b-col lg="3">
          <b-button
            variant="primary"
            style="margin: 20px 0"
            to="/self-assessment/submit-for-review"
            block
          >
            {{ $t("label_selfAssessment_submitReview_button") }}
          </b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import { createHelpers } from "vuex-map-fields";
import { mapGetters } from "vuex";

const { mapFields } = createHelpers({
  getterType: "getSelfAssessmentField",
  mutationType: "updateSelfAssessmentField",
});

export default {
  name: "SelfAssessmentLaborConditions",

  created: async function () {
    await this.$store.dispatch("SNAPSHOTS_GET");
    await this.$store.dispatch("BUSINESS_GET");
    this.$store
      .dispatch("SELF_ASSESSMENT_GET")
      .then(() => {
        this.$store.commit("setReloadSelfAssessment", false);
      })
      .catch((err) => {
        console.log(err);
        this.$router.push("/home"); // TODO Handle the error in a better way
      });
  },
  methods: {
    updateSelfAssessment: function (event) {
      var data = {};
      data[event.target.id] = event.target.value;
      this.$store.dispatch("SELF_ASSESSMENT_UPDATE", data);
    },
    shouldDisplayPolicy: function (key) {
      if (key === "internalExternalCommunication") {
        return false;
      }
      return true;
    },
  },
  computed: {
    ...mapGetters({
      selfAssessment: "getSelfAssessment",
      status: "getSelfAssessmentStatus",
      optionLists: "getOptionLists",
      getOptionListByName: "getOptionListByName",
      employmentPolicies: "getEmploymentPolicies",
      canUpdateSelfAssessment: "canUpdateSelfAssessment",
      getReloadSelfAssessment: "getReloadSelfAssessment",
    }),
    ...mapFields([
      "selfAssessment_employmentPolicies_externalCommunication_q5_inclusiveLanguage",
      "selfAssessment_employmentPolicies_externalCommunication_q6_commitment",
      "selfAssessment_employmentPolicies_externalCommunication_q7_nontraditionalGenderRoles",
      "selfAssessment_employmentPolicies_externalCommunication_q8_criteriaOfEquality",
      "selfAssessment_employmentPolicies_internalCommunication_q1_inclusiveLanguage",
      "selfAssessment_employmentPolicies_internalCommunication_q2_accesibility",
      "selfAssessment_employmentPolicies_internalCommunication_q3_commitment",
      "selfAssessment_employmentPolicies_internalCommunication_q4_criteriaOfEquality",
      "selfAssessment_employmentPolicies_preventionSexualHarassment_q39_informationExplicitProhibition",
      "selfAssessment_employmentPolicies_preventionSexualHarassment_q40_institutionalPolicy",
      "selfAssessment_employmentPolicies_preventionSexualHarassment_q41_annualTraining",
      "selfAssessment_employmentPolicies_preventionSexualHarassment_q42_responsiblesForMeasures",
      "selfAssessment_employmentPolicies_preventionSexualHarassment_q43_monitoringAndFollowing",
      "selfAssessment_employmentPolicies_preventionSexualHarassment_q44_awareness",
      "selfAssessment_employmentPolicies_preventionSexualHarassment_q45_documentedProcedures",
      "selfAssessment_employmentPolicies_preventionSexualHarassment_q46_trackOfComplaints",
      "selfAssessment_employmentPolicies_preventionSexualHarassment_q47_annualAwareness",
      "selfAssessment_employmentPolicies_preventionSexualHarassment_q48_staffAwareness",
      "selfAssessment_employmentPolicies_preventionSexualHarassment_q49_mechanismEffectiveness",
      "selfAssessment_employmentPolicies_promotion_q18_fairAssessments",
      "selfAssessment_employmentPolicies_promotion_q19_PromotionWithoutGenderBias",
      "selfAssessment_employmentPolicies_promotion_q20_internalPolicy",
      "selfAssessment_employmentPolicies_promotion_q21_concreteObjectivesMobility",
      "selfAssessment_employmentPolicies_promotion_q22_EnsureMenWomenAccessPromotions",
      "selfAssessment_employmentPolicies_promotion_q23_EnsureEqualRepresentation",
      "selfAssessment_employmentPolicies_promotion_q24_careerPaths",
      "selfAssessment_employmentPolicies_promotion_q25_criteriaOfEquality",
      "selfAssessment_employmentPolicies_recruitment_q10_aimForWomenToBalance",
      "selfAssessment_employmentPolicies_recruitment_q11_inclusiveLanguage",
      "selfAssessment_employmentPolicies_recruitment_q12_formalProcess",
      "selfAssessment_employmentPolicies_recruitment_q13_jobsReservedforWomen",
      "selfAssessment_employmentPolicies_recruitment_q14_jobsReservedforMen",
      "selfAssessment_employmentPolicies_recruitment_q15_equalOpportunities",
      "selfAssessment_employmentPolicies_recruitment_q16_prohibitDiscrimination",
      "selfAssessment_employmentPolicies_recruitment_q17_processEqualForMenWomen",
      "selfAssessment_employmentPolicies_recruitment_q9_promotion",
      "selfAssessment_employmentPolicies_training_q26_consistencyWithNeedsIdentified",
      "selfAssessment_employmentPolicies_training_q27_specificObjectivesOnGenderEquity",
      "selfAssessment_employmentPolicies_training_q28_EnsureMenWomenAccessTraining",
      "selfAssessment_employmentPolicies_training_q29_verficationOfTraining",
      "selfAssessment_employmentPolicies_training_q30_accessForNontraditionalPositions",
      "selfAssessment_employmentPolicies_training_q31_interferenceWithFamily",
      "selfAssessment_employmentPolicies_training_q32_annualTrainings",
      "selfAssessment_employmentPolicies_training_q33_criteriaOfEquality",
      "selfAssessment_employmentPolicies_wages_q34_ensureEqualPay",
      "selfAssessment_employmentPolicies_wages_q35_transparentInformation",
      "selfAssessment_employmentPolicies_wages_q36_implementationOfEqualPay",
      "selfAssessment_employmentPolicies_wages_q37_criteriaForAssigningSalary",
      "selfAssessment_employmentPolicies_wages_q38_fairWagePolicy",
      "selfAssessment_employmentPolicies_wlbs_q50_womanQuitJobDueBirthOrFamily",
      "selfAssessment_employmentPolicies_wlbs_q51_benefitsOfMaternity",
      "selfAssessment_employmentPolicies_wlbs_q52_workersFamilyAndPersonalNeeds",
      "selfAssessment_employmentPolicies_wlbs_q53_promotionOfCoparenting",
      "selfAssessment_employmentPolicies_wlbs_q54_supportForCareServicesChildrenOthers",
      "selfAssessment_employmentPolicies_wlbs_q55_flexibleWorking",
      "selfAssessment_employmentPolicies_wlbs_q56_worklifeBalance",
      "selfAssessment_employmentPolicies_wlbs_q57_absencesWithinWorkingHours",
      "selfAssessment_employmentPolicies_wlbs_q58_worklifeBalancePolicies",
      "selfAssessment_employmentPolicies_wlbs_q59_staffAwarenessWorklifeMeasures",
    ]),
  },
};
</script>

<style lang="sass" scoped>

.self-assesment .header h2
    margin: 0 105px 20px 0
.status
    position: absolute
    right: 30px
</style>
